import React, { useState, useEffect, createContext, memo } from "react";

import { transformData } from "../hooks/useData";
import { shuffle } from "../hooks/useShuffle";

import { useHttpClient } from "../hooks/httpHook";

export const GameContext = createContext([{}, () => {}]);

export const GameProvider = memo(({ children }) => {
  const { sendRequest, isLoading } = useHttpClient();
  const [avaliableGames, setAvaliableGames] = useState([]);
  const [chosenGame, setChosenGame] = useState("Nationellt");
  const [data, setData] = useState([]);
  const [game, setGame] = useState([]);
  const [correct, setCorrect] = useState(0);

  useEffect(() => {
    const fetchAvaliableGames = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_API_BASE}/game`
        );
        console.log(responseData);
        setAvaliableGames(responseData.places);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAvaliableGames();
  }, [sendRequest]);

  useEffect(() => {
    const fetchChosenGame = async () => {
      let game = avaliableGames.find((game) => game.title === chosenGame);

      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_API_BASE}/game/play`,
          "GET",
          null,
          {},
          {
            name: game.title,
            type: game.type,
          }
        );

        const transformedData = transformData(
          responseData.place.politicians,
          responseData.parties
        );

        setData(shuffle(transformedData));
      } catch (err) {}
    };
    fetchChosenGame();
  }, [sendRequest, chosenGame, avaliableGames]);

  return (
    <GameContext.Provider
      value={{
        chosenGame,
        setChosenGame,
        game,
        setGame,
        correct,
        setCorrect,
        avaliableGames,
        data,
        isLoading,
      }}
    >
      {children}
    </GameContext.Provider>
  );
});
